import { memo } from 'react';

import { type IconComponent } from '@air/design-icons';

export type AnnouncementGlyphProps = {
  icon?: IconComponent;
};

export const AnnouncementGlyph = memo(({ icon: Icon }: AnnouncementGlyphProps) => {
  if (!Icon) {
    return null;
  }

  return (
    <span className="mt-0.5 inline-flex shrink-0" data-testid="ANNOUNCEMENT_GLYPH">
      <Icon size="sm" />
    </span>
  );
});

AnnouncementGlyph.displayName = 'AnnouncementGlyph';
